var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 549,
    height: 354,
    viewBox: "0 0 549 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M399 272C474.111 272 535 211.111 535 136C535 60.8893 474.111 0 399 0C323.889 0 263 60.8893 263 136C263 211.111 323.889 272 399 272Z",
    fill: "#468189"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73 354C113.317 354 146 321.541 146 281.5C146 241.459 113.317 209 73 209C32.6832 209 0 241.459 0 281.5C0 321.541 32.6832 354 73 354Z",
    fill: "#F4E9CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166 191C190.301 191 210 171.301 210 147C210 122.699 190.301 103 166 103C141.699 103 122 122.699 122 147C122 171.301 141.699 191 166 191Z",
    fill: "#77ACA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M504.5 351C529.077 351 549 331.077 549 306.5C549 281.923 529.077 262 504.5 262C479.923 262 460 281.923 460 306.5C460 331.077 479.923 351 504.5 351Z",
    fill: "#9DBEBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.f39a3a84428b74ab0373d0e5003a7f30.svg";
export { ForwardRef as ReactComponent };